// The CRUD layer rejects ' " and ; in text fields (400). The Weekly Wave is loaded with typographic quotes, so
// the editors turn straight quotes into them when saving and in the translation output; a semicolon cannot be
// replaced without changing the text, so it is flagged and blocks saving.

const ENTITIES: Record<string, string> = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&apos;': "'" };

/** MyMemory answers with HTML entities (&#39;, &quot;): they carry a ; that crud would refuse. */
export const decodeEntities = (text: string): string => text.replace(/&(?:amp|lt|gt|quot|apos|#39);/g, (m) => ENTITIES[m]);

/** ' becomes ’; " becomes “ at the start, after a space or an opening bracket, and ” everywhere else. */
export const typographicQuotes = (text: string): string =>
  text.replace(/'/g, '’').replace(/"/g, (_m, offset: number, whole: string) => (offset === 0 || /[\s([{—]/.test(whole[offset - 1]) ? '“' : '”'));

/** Text as it is sent to crud: entities decoded, straight quotes made typographic. */
export const cleanCrudText = (text: string): string => typographicQuotes(decodeEntities(text));

export const hasSemicolon = (text: string | null | undefined): boolean => !!text && text.includes(';');

export const SEMICOLON_MESSAGE = 'A semicolon (;) cannot be saved. Use a comma or a period.';
